import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { NewBadge } from '../sf/NewBadge';
const levels = [{
  label: 'Employee rule',
  example: 'e.g. Drew Kim custom flat rule',
  matched: false
}, {
  label: 'Branch / Channel rule',
  example: 'None in v1 parity',
  matched: false
}, {
  label: 'Plan default',
  example: 'Matches Alex (Troy)',
  matched: true
}];
export function PrecedenceChain() {
  return <div data-id="element-395" data-mp="26t6uphuefeav">
      <p className="mb-2 flex flex-wrap items-center gap-2 text-xs font-semibold text-sf-weak" data-id="element-396" data-mp="26tf6t7ip6fl0">
        Which rule wins — most specific first <NewBadge data-id="element-397" data-mp="2btb30kl5l2q0" />
      </p>
      <ol className="flex flex-wrap items-stretch gap-2" data-id="element-398" data-mp="2gql10omlympg">
        {levels.map((level, index) => <li key={level.label} className="flex items-center gap-2" data-id="element-399" data-mp="2lpxjkx6g57m8" data-mpi={index}>
            <div className={`rounded border px-3 py-1.5 ${level.matched ? 'border-sf-green bg-sf-green-light' : 'border-sf-border bg-white'}`} data-id="element-400" data-mp="2ln1mfb2famyu">
              <p className="text-[13px] font-semibold" data-id="element-401" data-mp="ydt5wgd3624">
                {index + 1}. {level.label}
              </p>
              <p className={`text-xs ${level.matched ? 'text-sf-green-text' : 'text-sf-weak'}`} data-id="element-402" data-mp="1m5omcmxnh4yi">{level.example}</p>
            </div>
            {index < levels.length - 1 && <ChevronRightIcon className="h-4 w-4 text-sf-weak" aria-label="beats" data-id="element-403" data-mp="1d61kk010dx4x" />}
          </li>)}
      </ol>
    </div>;
}